<script lang="ts">
    import { onMount } from "svelte";
    import { Link } from "svelte-navigator";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { locationStore } from "../../../../store/locations";
    import { networkStore } from "../../../../store/networks";
    import { playerStore } from "../../../../store/players";
    import { user } from "../../../../store/stores";
    import PlayerCard from "./Components/PlayerCard.svelte";

    export let networkId: string;
    export let locationId: string;

    const getPlayersForLocation = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .playerClient.listPlayers({ location: locationId })
                .then((players) => {
                    playerStore.update((playerStore) => {
                        return {
                            ...playerStore,
                            players: players,
                        };
                    });
                });
        });
    };

    const getLocation = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .locationClient.getLocation({ locationId: locationId })
                .then((location) => {
                    locationStore.update((store) => {
                        return {
                            ...store,
                            location: location,
                        };
                    });
                });
        });
    };

    const getNetwork = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .networkClient.getNetwork({ networkId: networkId })
                .then((network) => {
                    networkStore.update((store) => {
                        return {
                            ...store,
                            network: network,
                        };
                    });
                });
        });
    };

    onMount(() => {
        if (
            !$locationStore.location ||
            $locationStore.location.id !== locationId
        ) {
            getLocation();
        }
        getPlayersForLocation();
        if (!$networkStore.network || $networkStore.network.id !== networkId) {
            getNetwork();
        }
    });
</script>

<div class="container">
    <div class="columns is-multiline">
        <div class="column is-one-third">
            <div class="card new-network">
                <Link to="new" class="new-network-link">
                    <span class="icon is-large">
                        <i class="fas fa-2x fa-plus" aria-hidden="true" />
                    </span>
                </Link>
            </div>
        </div>
        {#if $playerStore.players && $playerStore.players.entries}
            {#each $playerStore.players.entries as player}
                <div class="column is-one-third">
                    <PlayerCard {player} />
                </div>
            {/each}
        {/if}
    </div>
</div>

<style>
    .new-network {
        max-height: 27.7499rem;
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .new-network,
    :global(.new-network-link) {
        height: 70%;
        width: 70%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 15%;
    }
</style>
